import script from "./PageCrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageCrumbs.vue?vue&type=script&lang=ts&setup=true"

import "./PageCrumbs.vue?vue&type=style&index=0&id=8a2c573e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2c573e"]])

export default __exports__